import React from "react";
import { any, bool, number } from "prop-types";

function MenuItemSelector({ id, item, labelComponent, active, onClick, onClickChk }) {
  return (
    <div
      onClick={() => onClick(id)}
      key={id}
      className={`menu-selector__item ${active ? 'menu-selector__active' : ''}`}
    >
      <input
        type="checkbox"
        className="form-check-input me-2"
        onChange={() => onClickChk(id)}
        checked={item?.selected || false}
        onClick={(e) => e.stopPropagation()} // evita que tildar el checkbox dispare `onClick(id)`
      />
      <span className="d-md-inline">{labelComponent}</span>
    </div>
  );
}

MenuItemSelector.propTypes = {
  id: number,
  labelComponent: any,
  active: bool
};

MenuItemSelector.defaultProps = {
  id: undefined,
  labelComponent: "",
  active: false,
  onClick: () => {},
  onClickChk: () => {}
};

export default MenuItemSelector;
